export const createNewWebWorker = () =>
  new Worker(new URL("../webworker/webworker.js", import.meta.url));
